import { getFestivalsUpcoming } from "api/festivals/festivals";

export const queryFestivalsUpcoming = ({ user }) => ({
	queryKey: ["festivals-upcoming", user?.uid],
	queryFn: async () => getFestivalsUpcoming({ authToken: user?.accessToken }),
});
